import React from 'react'
import { connect } from 'react-redux'
import FlipMove from 'react-flip-move';
import SurvivorChip from '../components/SurvivorChip'

const createSurvivorStandings = (alive, snuffed) => {
  return [
    ...alive,
    {
      name: 'DIVIDER',
      id: 999
    },
    ...snuffed
  ]
}

let StandingBoard = ({ standings }) => (
  <div className="mdl-card mdl-shadow--2dp" id="standings">
      <div className="mdl-card__title">
          <h2 className="mdl-card__title-text">Standings</h2>
      </div>
      <h5>Alive</h5>
      <FlipMove duration={750} easing="ease-out">
      {standings.map((s, index) => (
        <SurvivorChip key={s.name} name={s.name}/>
      ))}
    </FlipMove>
  </div>
)

const mapStateToProps = (state, ownProps) => ({
  standings: createSurvivorStandings(state.standings.remainingSurvivors, state.standings.torchedSurvivors)
})

StandingBoard = connect(
  mapStateToProps
)(StandingBoard)

export default StandingBoard
